import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type RewardsSortOption =
  | "newest"
  | "oldest"
  | "pointsHigh"
  | "pointsLow"
  | "nameAsc"
  | "nameDesc";

export const DEFAULT_REWARDS_SORT_OPTION: RewardsSortOption = "newest";

const OPTIONS: SortOption<RewardsSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "pointsHigh", label: "Points (High to Low)" },
  { value: "pointsLow", label: "Points (Low to High)" },
  { value: "nameAsc", label: "Name (A-Z)" },
  { value: "nameDesc", label: "Name (Z-A)" },
];

export function rewardsSortOptionLabel(option: RewardsSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function rewardsSortOptionToParams(option: RewardsSortOption): {
  sortBy: "updatedAt" | "points" | "name";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "updatedAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "updatedAt", sortOrder: "ASC" };
    case "pointsHigh":
      return { sortBy: "points", sortOrder: "DESC" };
    case "pointsLow":
      return { sortBy: "points", sortOrder: "ASC" };
    case "nameAsc":
      return { sortBy: "name", sortOrder: "ASC" };
    case "nameDesc":
      return { sortBy: "name", sortOrder: "DESC" };
  }
}

export default function SortRewardsPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: RewardsSortOption;
  setSortOption: (option: RewardsSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Rewards"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
